import countries from 'country-list';
import Cookie from 'js-cookie';

import { parsedUrl } from '../services/url';
import { POS_COUNTRY_COOKIE } from '../settings/pointOfSale';

export const countryCode = parsedUrl.query[POS_COUNTRY_COOKIE] || Cookie.get(POS_COUNTRY_COOKIE) || '';

export const countryName = new countries().getName(countryCode);



// WEBPACK FOOTER //
// ./src/services/country.js